module.exports = __webpack_public_path__ + "static/media/10.bce4006a.svg";